import { useEffect, useRef } from "react";
import { trackEvent } from "../Components/Utility/Utility";

const SCROLL_MILESTONES = [25, 50, 75, 100];

const useScrollDepthTracking = () => {
  const trackedRef = useRef(new Set());

  useEffect(() => {
    const handleScroll = () => {
      const { scrollY, innerHeight } = window;
      const docHeight = document.documentElement.scrollHeight;
      const scrollPercent = Math.round(((scrollY + innerHeight) / docHeight) * 100);

      SCROLL_MILESTONES.forEach((milestone) => {
        if (scrollPercent >= milestone && !trackedRef.current.has(milestone)) {
          trackedRef.current.add(milestone);
          trackEvent("scroll_depth", {
            ecommerce: {
              page_name: window.location.pathname,
              page_url: window.location.href,
              scroll_percent: milestone,
            },
          });
        }
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
};

export default useScrollDepthTracking;
